import React from 'react'
import { Typography, LinearProgress } from '@mui/material'
import { LEGEND_COLOR_MAP_NEW } from '../../constants'
import { TableWrapper, TableCellHead, TableCellRow, ProgressBarWrapper } from './style'

const TableViewRowWithBars = ({ type='header', children, dataTypes='sentiments', data={}, maxValue=50, settings={showActions:false} }) => {
  // type = [header, row]
  // dataType = [sentiments, engagement, attributes]
  // data = {}
  const row = data || {}
  const isSentiments = [
    'Drivers', 'DriversAndSubBrands', 'DriversAndTriggers', 'DriversAndRatingImpacts', 'DriversMotivatorsDetractors', 
    'DriversAndSubBrandsMotivatorsDetractors', 'DriversAndTriggersMotivatorsDetractors', 'DriversAndRatingImpactsMotivatorsDetractors',
    'DriversProgression3Level_v1', 'SegmentDriversOnlyAnalysis3Level', 'SegmentDriversAnalysis', 'SegmentDriversOnlyAnalysis', 
  ].includes(row.insightsElementType)
  
  const classNm = isSentiments?'isSentiments':'isEngagement';

  return (
    <>
      {type === 'table' && (
        <TableWrapper>
          {children}
        </TableWrapper>
      )}
      {type === 'header' && (
        <>
          <TableCellHead className={`headingTitle ${classNm}`}>Drivers</TableCellHead>
          <TableCellHead className={`positivePercent ${classNm}`}>Positive</TableCellHead>
          <TableCellHead className={`neutralPercent ${classNm}`}>Neutral</TableCellHead>
          <TableCellHead className={`mixedPercent ${classNm}`}>Mixed</TableCellHead>
          <TableCellHead className={`negativePercent ${classNm}`}>Negative</TableCellHead>
          <TableCellHead className={`totalPercent ${classNm}`}>Total</TableCellHead>
          {settings?.showActions && <TableCellHead width='40px' className='headingActions'>Action</TableCellHead>}
        </>
      )}
      {type === 'row' && (
        <>
          <TableCellRow className='headingTitle'>{row?.DriverName}</TableCellRow>
          <TableCellRow className={`barWrap barWidth positivePercent ${classNm}`}><span className='barLabel' style={{background: LEGEND_COLOR_MAP_NEW.Positive }}> {row.PositivePercent}% </span><ProgressBar maxValue={maxValue} value={row.PositivePercent} color={LEGEND_COLOR_MAP_NEW.Positive} /></TableCellRow>
          <TableCellRow className={`barWrap barWidth neutralPercent ${classNm}`}><span className='barLabel' style={{background: LEGEND_COLOR_MAP_NEW.Neutral }}> {row.NeutralPercent}% </span><ProgressBar maxValue={maxValue} value={row.NeutralPercent} color={LEGEND_COLOR_MAP_NEW.Neutral} /></TableCellRow>
          <TableCellRow className={`barWrap barWidth mixedPercent ${classNm}`}><span className='barLabel' style={{background: LEGEND_COLOR_MAP_NEW.Mixed }}> {row.MixedPercent}% </span><ProgressBar maxValue={maxValue} value={row.MixedPercent} color={LEGEND_COLOR_MAP_NEW.Mixed} /></TableCellRow>
          <TableCellRow className={`barWrap barWidth negativePercent ${classNm}`}><span className='barLabel' style={{background: LEGEND_COLOR_MAP_NEW.Negative }}> {row.NegativePercent}% </span><ProgressBar maxValue={maxValue} value={row.NegativePercent} color={LEGEND_COLOR_MAP_NEW.Negative} /></TableCellRow>
          <TableCellRow className={`barWrap barWidth totalPercent ${classNm}`}><span className='barLabel' style={{background: LEGEND_COLOR_MAP_NEW.Total }}> {row.Percent}% </span><ProgressBar maxValue={maxValue} value={row.Percent} color={LEGEND_COLOR_MAP_NEW.Total} /></TableCellRow>
        </>
      )}
    </>
  )
}

export default TableViewRowWithBars

// Reusable Progress Bar Component
const ProgressBar = ({ value, color, maxValue }) => (
  <ProgressBarWrapper className='progressBar'>
    <LinearProgress
      variant='determinate'
      // value={value}
      value={(value / maxValue) * 100}
      sx={{
        width: 'calc(100% - 30px)',
        mr: 1,
        height: 6,
        bgcolor: '#ddd',
        '& .MuiLinearProgress-bar': { bgcolor: color },
      }}
    />
    <Typography variant='body2'>{value}%</Typography>
  </ProgressBarWrapper>
)
